import { FC } from 'react'

export const IconOutOfGaugeFrontRear: FC<{ zoom?: number; size?: number }> = ({ zoom, size }) => {
  return (
    <svg
      width={size ?? '32'}
      height={size ?? '32'}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={{ transform: `scale(${(zoom ?? 100) / 100})` }}
    >
      <path
        d='M12.0596 1H18.6243C18.8319 1 19 1.16824 19 1.37576V7.94055C19 8.27533 18.5952 8.44298 18.3586 8.20626L16.6499 6.49753C16.5031 6.35079 16.2652 6.35079 16.1184 6.49753L12.7259 9.88997C12.5792 10.0367 12.3413 10.0367 12.1945 9.88997L10.1101 7.8055C9.96331 7.65874 9.96331 7.42082 10.1101 7.27408L13.5025 3.88162C13.6493 3.73487 13.6493 3.49695 13.5025 3.3502L11.7938 1.64148C11.557 1.40475 11.7247 1 12.0596 1Z'
        fill='#212B36'
      />
      <path
        d='M7.97084 18.9918L1.37379 19C1.17217 19.0002 1.00852 18.8371 1.00827 18.6357L1 12.044C0.999597 11.7189 1.39261 11.5556 1.62288 11.7852L3.35819 13.5148C3.50094 13.6571 3.73208 13.6568 3.87447 13.5141L7.27565 10.1072C7.41803 9.96453 7.64918 9.96424 7.79192 10.1065L9.8928 12.2004C10.0355 12.3427 10.0358 12.5736 9.89341 12.7163L6.49222 16.1233C6.34984 16.266 6.35013 16.4969 6.49286 16.6391L8.22819 18.3688C8.45844 18.5982 8.29606 18.9914 7.97084 18.9918Z'
        fill='#212B36'
      />
    </svg>
  )
}

export default IconOutOfGaugeFrontRear
